import {
  SET_THEME_COLOR,
  SET_GRADIENT_COLOR,
  SETCANCELCHEQUE,
  SETBANKSTATEMENT,
  SETEXCHANGESEGMENT,
  SETNOMINEEPROOFVALIDATE,
  REACTIVATION_PROOF,
  ACCOUNTCLOSURESCREEN,
} from "./types";

const initialState = {
  headingTextColor: "#0CABC4",
  background: "",
  iconsColor: "#0CABC4",
  gradientColor: [],
  titleColor: "#0cabc4",
  inputLabelColor: "#000000",
  inputPlaceholderColor: "#000000",
  inputIconColor: "#0cabc4",
  inputError: "#FF0000",
  buttonColor: "",
  themeTemplate: "106",
  cancelChequeField: "",
  bankStatementField: "",
  exchangeSegment: [],
  hasNomineeProofValidate: "No",
  hasReactivationProof: "No",
  accountClosureScreen: 0,
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME_COLOR:
      return {
        ...state,
        headingTextColor: action.data.headingtextcolor,
        background: action.data.baackground,
        iconsColor: action.data.iconscolor,
        titleColor: action.data.titlecolor,
        inputLabelColor: action.data.inputlabelcolor,
        inputPlaceholderColor: action.data.inputplaceholdercolor,
        inputIconColor: action.data.inputiconcolor,
        inputError: action.data.inputerror,
        buttonColor: action.data.buttoncolor,
        themeTemplate: action.data.theme_template,
      };
    case SET_GRADIENT_COLOR:
      let colors = action.data;
      let arr = [];
      for (let i in colors) {
        arr.push(colors[i].gcolor);
      }
      return {
        ...state,
        gradientColor: arr,
      };
    case SETCANCELCHEQUE:
      return {
        ...state,
        cancelChequeField: action.payload,
      };
    case SETBANKSTATEMENT:
      return {
        ...state,
        bankStatementField: action.payload,
      };
    case SETEXCHANGESEGMENT:
      return {
        ...state,
        exchangeSegment: action.payload,
      };
    case SETNOMINEEPROOFVALIDATE:
      return {
        ...state,
        hasNomineeProofValidate: action.payload,
      };
    case REACTIVATION_PROOF:
      return {
        ...state,
        hasReactivationProof: action.payload,
      };
    case ACCOUNTCLOSURESCREEN:
      return {
        ...state,
        accountClosureScreen: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default themeReducer;
